import "bootstrap/dist/css/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
// import logoImg from 'assets/logos/TMLogo.png';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './App.css';
import ThemeSideMenu from "components/general/ThemeSideMenu";
import AppRouter from "_routes/AppRouter";
import { NavigationProvider } from "components/navigation/NavigationContext";
import BottomNavigation from "components/navigation/BottomNavigation";
import { useLocation } from "react-router-dom";

function App() {

  const url = process.env.REACT_APP_URL;
  const isDisplayRoute = useLocation().pathname.startsWith('/display');
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "system";
  });

  const [clubInfo, setClubInfo] = useState({});

  useEffect(() => {
    // Fetch club info from API
    const fetchClubInfo = async () => {
      try {
        const response = await fetch(`${url}/club`);
        const textResponse = await response.text(); // Read raw response as text
        // console.log("Raw API response:", textResponse); // Debugging

        if (!response.ok) {
          throw new Error(`Failed to fetch club info: ${response.status} ${response.statusText}`);
        }

        const data = JSON.parse(textResponse); // Parse JSON manually
        // console.log("Parsed club info:", data); // Debugging
        setClubInfo(data[0]);
      } catch (error) {
        console.error("Failed to fetch club info:", error);
      }
    };

    fetchClubInfo();
  }, [url]);

  useEffect(() => {
    if (theme === "system") {
      document.body.dataset.theme = getSystemTheme();
    } else {
      document.body.dataset.theme = theme;
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  function getSystemTheme() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }

  useEffect(() => {
    if (theme !== "system") return;

    const handler = () => {
      document.body.dataset.theme = getSystemTheme();
    };

    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", handler);
    handler();

    return () => {
      window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", handler);
    };
  }, [theme]);

  useEffect(() => {
    if (clubInfo.name && clubInfo.type) {
      // console.log("Updating meta tags with:", clubInfo); // Debugging

      // Update meta tags dynamically
      document.title = clubInfo.name;
      const metaDescription = document.querySelector("meta[name='description']");
      if (metaDescription) {
        metaDescription.setAttribute("content", clubInfo.type);
      } else {
        // console.warn("Meta description tag not found in the DOM.");
      }
    }
    // else {
    //   console.warn("Club info is incomplete. Name or type is missing.", clubInfo);
    // }
  }, [clubInfo]);

  return (
    <>
      <ToastContainer />
      <div className="App">
        <NavigationProvider>
          {!isDisplayRoute && <ThemeSideMenu theme={theme} setTheme={setTheme} />}
          <AppRouter />
          {!isDisplayRoute && <BottomNavigation theme={theme} setTheme={setTheme} />}
        </NavigationProvider>
      </div>
    </>
  );
}

export default App;
